import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  locationContainer: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  name: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;

    color: ${theme.colors.neutral.variant[50]};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
